import http from "./Http";

// ======================================================
// 🔹 GENERAR TITULOS DE UNIDADES (AHORA CON PRIORIDAD)
// ======================================================

const generarUnidades = async (n) => {
  const res = await http.get("/sac/generar-unidades", {
    params: { n }
  });

  // Backend devuelve: { unidades: [ {nombre_unidad, prioridad}, ... ] }
  return res.data.unidades.map((item, index) => ({
    id: index + 1,
    nombre: item.nombre_unidad,
    prioridad: item.prioridad
  }));
};

const generarSituacionSignificativa = async (titulosUnidades) => {
  // El backend espera SOLO un array en el body
  const res = await http.post(
    "/sac/generar_situacion_significativa",
    titulosUnidades
  );

  // Validación defensiva
  if (!res.data || !Array.isArray(res.data.respuesta)) {
    throw new Error("El backend no devolvió un array válido en 'respuesta'");
  }

  // Transformar formato del backend al esperado por Step5
  return res.data.respuesta.map((item, index) => ({
    id: index + 1,
    nombre: item.nombre_unidad,
    situacion: item.situacion_signif
  }));
};

const regenerarUnidad = async (nombresExistentes = []) => {
  const nombresNormalizados = new Set(
    (Array.isArray(nombresExistentes) ? nombresExistentes : [])
      .map((nombre) => (nombre || "").trim().toLowerCase())
      .filter(Boolean)
  );

  const candidatas = await generarUnidades(4);
  const siguienteUnidad =
    candidatas.find(
      (item) => !nombresNormalizados.has((item.nombre || "").trim().toLowerCase())
    ) || candidatas[0];

  if (!siguienteUnidad) {
    throw new Error("No se pudo obtener una unidad alternativa.");
  }

  return siguienteUnidad;
};

const regenerarSituacion = async (nombreUnidad) => {
  // enviar un array con 1 solo elemento
  const res = await http.post("/sac/generar_situacion_significativa", [
    nombreUnidad
  ]);

  if (!res.data || !Array.isArray(res.data.respuesta)) {
    throw new Error("Error al regenerar situación: formato inesperado");
  }

  const item = res.data.respuesta[0];

  return {
    situacion: item.situacion_signif,
    nombre: item.nombre_unidad
  };
};


const GenerarUnidadesService = {
  generarUnidades,
  regenerarUnidad,
  generarSituacionSignificativa,
  regenerarSituacion,
};

export default GenerarUnidadesService;
